<template>
  <el-card class="fla__card">
    <FilmmakerDetailsForm
      ref="formFilmmakerDetails"
      :value="value"
      v-bind="$attrs"
      @input="newValue => $emit('input', newValue)"
      showEmail
    />
  </el-card>
</template>

<script>
import FilmmakerDetailsForm from '@/components/Profile/FilmmakerDetailsForm';

export default {
  inheritAttrs: false,
  components: {
    FilmmakerDetailsForm,
  },
  props: {
    licenseRendererVm: {
      type: Object,
      required: true,
    },
    value: {
      type: Object,
      required: true,
    },
  },
  mounted() {
    this.$nextTick(() => {
      this.licenseRendererVm.addReference('formFilmmakerDetails', this.$refs.formFilmmakerDetails);
    });
  },
};
</script>



// WEBPACK FOOTER //
// src/components/Licenses/CommonLicenseComponents/AppSpecificLicenseComponent/AppYourDetails.vue